var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBioenergie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_3365",
    "data-name": "Rettangolo 3365",
    width: 17.218,
    height: 24.25,
    fill: "#a9a9a9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Bioenergie1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bioenergie1",
    clipPath: "url(#clip-Bioenergie1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_35600",
    "data-name": "Raggruppa 35600",
    transform: "translate(4 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_32934",
    "data-name": "Raggruppa 32934",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_26734",
    "data-name": "Tracciato 26734",
    d: "M16.094.893A1.122,1.122,0,0,0,14.5.116C12.736.988,6.813,4.044,4.6,6.79A6.751,6.751,0,0,0,4.1,7.5C2.992,7.018,1.98,6.657,1.486,6.488a1.042,1.042,0,0,0-1.381.906c-.09,1.187-.324,5.218.434,7.258A4.546,4.546,0,0,0,3.17,17.294a4.672,4.672,0,0,0,3.2.069.849.849,0,0,0-.05.251v5.722a.916.916,0,0,0,1.831,0V18.091a7.222,7.222,0,0,0,1.81.232,7.327,7.327,0,0,0,3.509-.9,7,7,0,0,0,3.488-4.564C17.752,9.42,16.5,2.831,16.094.893M6.02,7.941c1.252-1.55,4.286-3.5,7.133-5.06l-4.08,8.439a4.461,4.461,0,0,0-1.06-1.561,10.1,10.1,0,0,0-2.24-1.478c.079-.115.157-.23.246-.34m.727,3.15a2.672,2.672,0,0,1,.825,2.06,2.889,2.889,0,0,1-.524,1.54L3.407,9.2a12.814,12.814,0,0,1,3.34,1.893M3.833,15.579a2.666,2.666,0,0,1-1.57-1.567,12.847,12.847,0,0,1-.424-3.855L5.51,15.7a2.9,2.9,0,0,1-1.677-.116m11.345-3.126A5.1,5.1,0,0,1,12.6,15.818a5.47,5.47,0,0,1-3.915.519L14.764,3.758c.527,3.2.855,6.768.414,8.694",
    transform: "translate(0 0)",
    fill: "#a9a9a9"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBioenergie);
export default __webpack_public_path__ + "static/media/Bioenergie.92f78123d8e849b34ae8f2ebcfb464d1.svg";
export { ForwardRef as ReactComponent };